import { render, staticRenderFns } from "./GFLoanDocuments.vue?vue&type=template&id=29616f1a"
import script from "./GFLoanDocuments.vue?vue&type=script&lang=js"
export * from "./GFLoanDocuments.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports